export default __webpack_public_path__ + "static/12-1fa74c8842a54f2bc46db5cd35e74b67.jpg";